export const useMatchTextWIthImages = (taskAnswer) => {

    const isCorrect = (questionId: string) => {
        if (!taskAnswer) return undefined;
      
        const userAnswer = taskAnswer.userAnswer?.[questionId];
        const correctAnswer = taskAnswer.correctAnswer?.[questionId]?.[0];
        
        if (userAnswer === undefined || correctAnswer === undefined) {
            return undefined; 
        }
        
        return userAnswer === correctAnswer;
    };

    return {
        isCorrect
    }
}